import { Outlet } from "react-router-dom";

import { ActiveWorkspaceProvider } from "~/entities/workspace";

import { AppPortalProvider } from "./portal-provider";

/**
 * Layout для full-screen роутов без сайдбара (ревью-вьювер папки). Даёт те же провайдеры, что и
 * `AppLayout` — workspace-контекст, портал-контейнер, `dark`-тему — но без `AppSidebar`/
 * `SidebarProvider`. Без него `useActiveWorkspace` на таком роуте кидает (провайдер живёт внутри
 * `AppLayout`, а роут ревью — top-level вне него) → монтирование падает в пустой экран.
 */
export function FullscreenLayout() {
    return (
        <AppPortalProvider className="app-root dark min-h-screen">
            <ActiveWorkspaceProvider>
                <Outlet />
            </ActiveWorkspaceProvider>
        </AppPortalProvider>
    );
}
